import {callAPI} from '@/store/utils'; // eslint-disable-line
import {base} from './utils';

// Fiscal years (exercice comptable). Forward-only status machine
// draft → open → closed; a closed year is immutable. Composed into the
// `accounting` namespace by ./index.js.
export default {
  state: {
    fiscalYears: [],
    fiscalYearsLoaded: false,
  },
  getters: {
    fiscalYears: (state) => state.fiscalYears,
    fiscalYearsLoaded: (state) => state.fiscalYearsLoaded,
  },
  mutations: {
    setFiscalYears(state, list) {
      state.fiscalYears = list || [];
      state.fiscalYearsLoaded = true;
    },
  },
  actions: {
    async actionGetFiscalYears({commit}) {
      const res = await callAPI('GET', `${base()}/fiscal-years`);
      if (res && !res.error) commit('setFiscalYears', res.result);
      return res;
    },
    // body: { start_date (req), end_date (req), label?, status?='draft' }
    async actionCreateFiscalYear(_ctx, body) {
      // Client-generated id (app convention).
      return callAPI('POST', `${base()}/fiscal-years`, {
        id: window.utils.genId(),
        ...body,
      });
    },
    // body: { label?, start_date?, end_date? } — 400 if the year is closed.
    async actionUpdateFiscalYear(_ctx, {id, ...body}) {
      return callAPI('PATCH', `${base()}/fiscal-years/${id}`, body);
    },
    // status ∈ 'open' | 'closed' (forward-only from the current status).
    async actionSetFiscalYearStatus(_ctx, {id, status}) {
      return callAPI('POST', `${base()}/fiscal-years/${id}/status`, {status});
    },
  },
};
